import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_2 = {
  key: 2,
  class: "d-flex align-center flex-wrap ga-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_rel_option = _resolveComponent("ontos-rel-option")!
  const _component_ontos_rel_selection = _resolveComponent("ontos-rel-selection")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_ontos_lane_value = _resolveComponent("ontos-lane-value")!
  const _component_ontos_form_dialog = _resolveComponent("ontos-form-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_form_dialog, {
    title: _ctx.title,
    subtitle: _ctx.subtitle,
    "max-width": "560px",
    loaded: !_ctx.loading,
    saving: _ctx.saving,
    "save-disabled": !_ctx.chosen.length,
    dirty: _ctx.chosen.length > 0,
    onSave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('link', _ctx.chosen))),
    onClosed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('closed')))
  }, {
    default: _withCtx(() => [
      (!_ctx.candidates.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$tt('relationship-link-none', {collection: _ctx.collection})), 1))
        : (_openBlock(), _createBlock(_component_v_autocomplete, {
            key: 1,
            modelValue: _ctx.chosen,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chosen) = $event)),
            items: _ctx.candidates,
            label: _ctx.collection,
            "item-title": "_identifier",
            "item-value": "_instance",
            multiple: "",
            autofocus: "",
            "auto-select-first": ""
          }, {
            item: _withCtx(({item, props}) => [
              _createVNode(_component_ontos_rel_option, _mergeProps(props, { item: item }), null, 16, ["item"])
            ]),
            selection: _withCtx(({item}) => [
              _createVNode(_component_ontos_rel_selection, {
                item: item,
                removable: "",
                onRemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.remove($event)))
              }, null, 8, ["item"])
            ]),
            _: 1
          }, 8, ["modelValue", "items", "label"])),
      (_ctx.restriction.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restriction, (value) => {
              return (_openBlock(), _createBlock(_component_ontos_lane_value, {
                key: value.dimension.key,
                named: "",
                value: value,
                context: _ctx.targetContext,
                onLink: _cache[2] || (_cache[2] = ($event: any) => ($event.event.preventDefault()))
              }, null, 8, ["value", "context"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "subtitle", "loaded", "saving", "save-disabled", "dirty"]))
}